/**
 * groupColor.js
 *
 * Génère une couleur hex déterministe et visuellement agréable
 * à partir d'un identifiant de groupe d'analyse.
 * Le même id produit toujours la même couleur (stable, sans état).
 */

function _hash(str) {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
        h = (Math.imul(31, h) + str.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
}

function _hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n) => {
        const k = (n + h / 30) % 12;
        const c = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * c).toString(16).padStart(2, "0");
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

/**
 * Retourne une couleur hex vive et lisible pour un identifiant de groupe.
 * Saturation élevée (62 %), luminosité 40 % → bon contraste sur fond blanc.
 *
 * @param {string} id - Identifiant du groupe (ex: "correlation", "anomaly-detection")
 * @returns {string} Couleur hex (ex: "#3a82c4")
 */
export function groupColor(id) {
    const hue = _hash(String(id)) % 360;
    return _hslToHex(hue, 62, 40);
}

